import { Context, PropsWithChildren, createContext } from "react";
import {
  HashedDynamicPermission,
  HashedPermission,
  Org,
  UserLayoutQuery,
} from "@songtradr-one/shared-common";
import { AppLayoutConfig } from "../../layouts/App.Parts";

// TEXT

// STYLES

// DATA

// TYPES
export interface IAppContext {
  user?: User;
  setUser: (user?: User) => void;
  currentOrg?: CurrentOrg;
  setCurrentOrg: (currentOrg: CurrentOrg, effectiveUser?: User) => void;
  switchOrg: (newOrgId: string) => Promise<void>;
  refreshContext: (matchOrgId?: string) => Promise<void>;
  hasPermission: hasPermission;
  hasAnyPermission: hasPermissions;
  hasAllPermissions: hasPermissions;
  appConfig: AppLayoutConfig;
}

export type User = UserLayoutQuery["user"];

export type CurrentOrg = Omit<
  Org,
  "__typename" | "createDate" | "modules" | "roles"
>;

export type hasPermissions = (
  permissions: (HashedPermission | HashedDynamicPermission)[],
) => boolean;

export type hasPermission = (
  permission: HashedPermission | HashedDynamicPermission,
) => boolean;

export interface ProviderProps extends PropsWithChildren {
  appConfig: AppLayoutConfig;
}

// CONSTANTS
export const AppContext: Context<IAppContext> = createContext<IAppContext>({
  user: undefined,
  setUser: () => null,
  currentOrg: undefined,
  setCurrentOrg: () => null,
  switchOrg: async () => await Promise.resolve(),
  refreshContext: async () => await Promise.resolve(),
  hasPermission: () => false,
  hasAnyPermission: () => false,
  hasAllPermissions: () => false,
  appConfig: {} as AppLayoutConfig,
});

// FUNCTIONS

// ASSETS
